import axios from "../axiosConfig";
import { currentLanguage } from "../../algorithms/storage";

export const getAllCommunities = (pageNumber = 1, pageSize = 2, token) => {
  return axios.get(`Community/GetAll/${pageNumber}/${pageSize}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Accept-Language": currentLanguage(),
    },
  });
};

export const getCommunity = (communityId, token) => {
  return axios.get(`Community/Details/${communityId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getCommunityCounts = (communityId, token) => {
  return axios.get(`Community/GetAllCount/${communityId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getCommunityRoles = (token) => {
  return axios.get(`Community/GetCommunityRoles`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getCommunityMembers = (roleId, communityId, token) => {
  return axios.get(
    `Community/GetUserRoleByCommunity?RoleId=${roleId}&communityId=${communityId}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
export const addRolesCommunityMembers = (roleId, communityId, body, token) => {
  return axios.post(
    `Community/AddCommunityRoles?communityId=${communityId}&RoleId=${roleId}`,
    body,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
